import { render, staticRenderFns } from "./FrameCard.vue?vue&type=template&id=5f7a0058&scoped=true&"
import script from "./FrameCard.vue?vue&type=script&lang=js&"
export * from "./FrameCard.vue?vue&type=script&lang=js&"
import style0 from "./FrameCard.vue?vue&type=style&index=0&id=5f7a0058&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7a0058",
  null
  
)

export default component.exports